import {fromPairs, createSelector, createStructuredSelector} from 'helpers';
import {mood} from './mood';
import {diary} from './diary';
import {images} from 'store/files/selectors';
import {collaboration, editable} from 'store/relations';
import {saved} from 'store/server';

const special = createSelector(
  diary,
  diary => diary && /Daily Check-In|Morning Thoughts|Reflections|My Mood/i.test(diary.subject),
);

const questions = createSelector(
  diary,
  diary => {
    if (diary && /Daily Check-In|Morning Thoughts|Reflections/i.test(diary.subject) && diary.text) {
      const pairs = diary.text.split('\n\n').map(pair => {
        const lastLineBreakIndex = pair.lastIndexOf('\n');
        if (lastLineBreakIndex === -1) {
          return [pair.trim(), ''];
        }
        const question = pair.slice(0, lastLineBreakIndex).trim();
        const answer = pair.slice(lastLineBreakIndex + 1).trim();
        return [question, answer];
      });
      return fromPairs(pairs);
    }
  }
);

export const details = createStructuredSelector({
  collaboration,
  diary,
  editable,
  images,
  mood,
  questions,
  saved,
  special,
});
